// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"378":"user","818":"auth"}[chunkId] || chunkId) + "." + {"49":"1cd1a52e","378":"1c589903","818":"13e0185f"}[chunkId] + ".css";
};